import router from "@/router";

export default () => {
  const { currentRoute } = router;
  const { viewMode, id } = currentRoute.params;
  const { view } = currentRoute.query;

  if (!viewMode || !view) return "";

  if (id) return "Detail";
  if (viewMode === "list") {
    if (view === "long") return "Standard";
    if (view === "short") return "Compact";
    return "List";
  }

  return `${viewMode.charAt(0).toUpperCase()}${viewMode.substring(1)}`;
};
